import httpClient from './httpClient';

const TAG_FILTERS_END_POINT = '/backoffice/tag-filters';

export const getTagFiltersAPI = (params) => httpClient.get(TAG_FILTERS_END_POINT, { params });
export const getTagFilterAPI = (id) => httpClient.get(`${TAG_FILTERS_END_POINT}/${id}`);
export const createTagFilterAPI = (params) => httpClient.post(TAG_FILTERS_END_POINT, params);
export const updateTagFilterAPI = (id, params) => httpClient.put(`${TAG_FILTERS_END_POINT}/${id}`, params);
export const deleteTagFilterAPI = (id) => httpClient.delete(`${TAG_FILTERS_END_POINT}/${id}`);
